import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FileUploadDisplay_ListRow.html?raw';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { FileUploadTypes } from "../FileUploadTypes";
import { FileHelpers, StringHelpers } from "../../../../../more/Helpers";



class FileUploadDisplay_ListRow extends compose(_WidgetBaseSP) {
    templateString: any = template;


    private txtFileName: HTMLElement;
    private txtFileSize: HTMLElement;
    private txtFileType: HTMLElement;
    private fileIcon: HTMLElement;
    private additionalContentContainer: HTMLElement;
    private file: FileUploadTypes.UploadDescriptor;

    private _lastRemoveResponse: any = null;

   
    private _onclickRemoveFile(evt?: Event): void {
        evt.preventDefault();
        this.removeUploadedFile();
        evt.stopPropagation();
    }

    private iconMap: Record<string, string> = {
        PNG: "fas fa-file-image",
        BMP: "fas fa-file-image",
        JPG: "fas fa-file-image",
        JPEG: "fas fa-file-image",
        HEIC: "fas fa-file-image",
        TIFF: "fas fa-file-image",
        GIF: "fas fa-file-image",
        ICO: "fas fa-file-image",
        PDF: "fas fa-file-pdf",
        DOC: "fas fa-file-word",
        DOCX: "fas fa-file-word",
        CSV: "fas fa-file-csv",
        XLS: "fas fa-file-excel",
        XLSX: "fas fa-file-excel",
        TXT: "fas fa-file-alt",
        ZIP: "fas fa-file-archive",
        AVI: "fas fa-file-video",
        MKV: "fas fa-file-video",
        WMV: "fas fa-file-video",
        MOV: "fas fa-file-video",
        "7Z": "fas fa-file-archive"

};

    getData(): FileUploadTypes.UploadDescriptor {
        return this.file;
    }
    setData(data: FileUploadTypes.FileData, guid: string) {
        this.file = { ...data, uploadGUID: guid };

        this.displayValues();
    }

    removeUploadedFile(): void {
        this.StandbyStart();
        
        let requestUrl = window.appRoot + "filetransfer/remove" // neu wäre callfunction: FileTransfer_RemoveFileFromUpload
        let requestParams = { "jsonData": JSON.stringify({ guid: this.file.uploadGUID, fileName: this.file.FileName }) };
        this.RequestManager.post(
            requestUrl, 
            requestParams,
            lang.hitch(this,this._remove_completeHandler),
            lang.hitch(this, this._remove_errorHandler)
        );
    }

    private _remove_completeHandler() {
        this.StandbyStop();
        this.emit("fileRemoved", this.file);
    }

    private _remove_errorHandler(error) {
        this.StandbyStop();
        this._lastRemoveResponse = error;
        console.error("_remove_errorHandler", "this._lastRemoveResponse", this._lastRemoveResponse);
        this.emit("fileRemove_error", error.Message);
    }

    private displayValues(): void {
        if (this.file.uploadGUID && this.file.FileName) {
            this.UiModder.domAttr.set(this.txtFileName, "innerHTML", this.file.FileName);
            this.UiModder.domAttr.set(this.txtFileName, "title", this.file.FileName);
            let filesizeStr = StringHelpers.formatBytes(this.file.FileSize);
            let fileTypeStr = this.file.FileType;

            this.UiModder.domAttr.set(this.txtFileSize, "innerHTML", filesizeStr ? filesizeStr : "");
            this.UiModder.domAttr.set(this.txtFileType, "innerHTML", fileTypeStr ? fileTypeStr : "");

            if (this.file.FileType) {
                let extension = this.file.FileType.toUpperCase();

                let icon = FileHelpers.getIconClassForFileType(extension);
                if (icon) {
                    this.UiModder.domClass.remove(this.fileIcon);
                    this.UiModder.domClass.add(this.fileIcon, icon);
                }
            }
        }
    }
    addContent_LEGACY(bool: boolean, element: HTMLElement | string): void {
        this.UiModder.domConstruct.empty(this.additionalContentContainer);
        this.addContent(element);
    }
    addContent(element: HTMLElement | string): void {

        this.hideNode(this.additionalContentContainer, !element);

        //showSecondElement ? this.UiModder.domClass.replace(this.fileFileNameContainer, "halfElement", "singleElement") : this.UiModder.domClass.replace(this.fileFileNameContainer, "singleElement", "halfElement");

        if (!element) return;

        switch (typeof element) {
            case "string":
                this.additionalContentContainer.innerHTML = element;
                break;
            default:
                this.UiModder.domConstruct.place(element, this.additionalContentContainer);
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        //
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.displayValues();
        //this.inherited(arguments);
    }
}

export default mdsWidget(FileUploadDisplay_ListRow);